import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function Protected({ children, requireRole }: { children: React.ReactNode; requireRole?: string[] }) {
  const { user, role, loading } = useAuth();
  if (loading) return <div className="p-8 text-slate-500">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireRole && (!role || !requireRole.includes(role))) {
    return <div className="p-8 text-red-600">Sem permissão (role atual: {role ?? 'none'})</div>;
  }
  return <>{children}</>;
}
